{#if labelText}
  <label data-heap-photo-button="use other" 
         class="ne-file-label" 
         for="ne-file-input">
    {labelText}
  </label>

  <input class="ne-hide"
         id="ne-file-input"
         bind:this={fileInput}
         on:change="{event => uploadPhoto(event)}"
         data-test-file-input
         data-heap-photo-button="use other"
         type="file"
         accept="image/*">
{:else}
  {#if $photo.hasPhoto}
    <div class="ne-uploaded-container">
      <img class="ne-thumbnail"
           src={$photo.photoSrc.state}
           alt="Uploaded photo thumbanil" />
      <div class="ne-button-container">
        <label class="ne-file-label"
               for="edit">
          <Button dark={true}>
            Edit/Change Photo
          </Button>
        </label>
        <input class="ne-hide"
                id="edit"
                bind:this={fileInput}
                on:click="{toggleModal}"
                readonly="true"
                daPta-heap-photo-button="edit"
                data-test-file-input />
        <label class="ne-file-label"
                for="remove">
          <Button> 
            Remove Photo
          </Button>
        </label>
        <input class="ne-hide"
               id="remove"
               bind:this={fileInput}
               on:click="{removePhoto}">
      </div>
    </div>
  {:else}
    <div class="ne-upload-container">
      {#if $photo.addingPhoto.state}
        <PhotoUploadProgress progress={$photo.photoUploadProgress.state} />
      {:else}
        <label class="ne-upload-label"
               for="upload">
          <Button>
            <AddImageIcon />
            Upload Photo (optional)
          </Button>
        </label>
        <input class="ne-upload-input"
               bind:this={fileInput}
               on:change="{event => uploadPhoto(event)}"
               data-test-file-input
               data-heap-photo-button="add"
               data-test-component="note-edit-button-photo"
               id="upload"
               type="file"
               accept="image/*"
               tabindex="0">
      {/if}
    </div>
  {/if}
{/if}

<style>
  .ne-hide {
    opacity: 0;
    position: absolute;
    left: 0;
    width: 1px;
  }

  .ne-file-label {
    cursor: pointer;
  }

  .ne-thumbnail {
    height: 95px;
    width: 95px;
    margin: 10px 15px;
  }

  .ne-upload-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 30%;
    margin-bottom: 10px;
    cursor: pointer;
    pointer-events: all;
  }

  .ne-uploaded-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 30%;
    margin-bottom: 10px;
    border: 1px solid #d3d3d3;
  }

  .ne-upload-label {
    cursor: pointer;
    width: 100%;
    height: 30%;
    position: absolute;
    z-index: 1;
    border: 2px dashed #d3d3d3;
    background: #fff;
  }

  .ne-upload-input {
    width: 100%;
    height: 30%;
    position: absolute;
    z-index: -1;
  }

  .ne-button-container {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    flex-direction: column;
  }

  @media (min-width: 540px) {
    .ne-button-container {
      flex-direction: row;
    }
  }
</style>

<script>
  import { store, photo } from '../stores';
  import { imageDimensionsTooSmall } from '../lib/image-utils';
  import PhotoUploadProgress from './PhotoUploadProgress.html';
  import Button from './Button.html';
  import AddImageIcon from './AddImageIcon.html';

  export let cover = true;
  export let labelText = null;
  let fileInput;

  function toggleModal() {
    photo.set($photo.isEditingPhoto.toggle());
  };

  function removePhoto() {
    store.set($store.selectLayout('text'));
    photo.set($photo.photoSrc.set(''));
  };

  function uploadPhoto(event) {
    const { target: { files } } = event;
    let newState = $store;
    let newPhotoState = labelText
      ? $photo.addingPhoto.set(true).isChangingPhoto.set(true)
      : $photo.addingPhoto.set(true);

    photo.set(newPhotoState);

    if (files[0]) {
      const reader = new FileReader();

      reader.onprogress = ({ total, loaded }) => {
        const photoUploadProgress = (loaded / total) * 100;
        photo.set($photo.photoUploadProgress.set(photoUploadProgress));
      }

      reader.onload = async ({ target: { result }}) => {
        let newPhotoState = $photo.addingPhoto.set(false);
        let newState = $store;

        const tooSmall = await imageDimensionsTooSmall(result);
        newState = tooSmall
          ? newState.addWarning('The image is a smaller resolution than we recommend and may print blurry')
          : newState;

        if ($photo.isChangingPhoto.state) {
          /*
           * update Cropper src when uploading in
           * the photo editor modal
           */
          await $photo.cropper.state.replace(result);
        }

        store.set(newState);
        photo.set(newPhotoState.commitPhotoEdits(result).originalPhotoSrc.set(result));
      }

      reader.readAsDataURL(files[0]);
      fileInput.value = '';
    }
    store.set($store.selectLayout('photo'));
  }
</script>
